import type { JSX } from 'react';
import type { WireOverview } from '@logistics/contracts';
import { navigate } from '../shell/use-route';
import { statTiles } from './stats';

export function StatTiles({ overview }: { overview: WireOverview }): JSX.Element {
  return (
    <div className="col-span-full grid grid-cols-2 gap-3.5 desk:grid-cols-4">
      {statTiles(overview).map((tile) => (
        <button
          key={tile.label}
          type="button"
          onClick={() => navigate(tile.to)}
          className="bg-surf hover:border-acc rounded-[14px] border px-5 py-[18px] text-left text-inherit transition-[border-color,transform] duration-200 hover:-translate-y-0.5"
        >
          <div className="text-mute font-mono text-[11px] tracking-[.1em]">{tile.label}</div>
          <div className="mt-2 flex items-baseline gap-2">
            <span className="text-[30px] font-semibold tracking-[-.02em]">{tile.value}</span>
            <span className="text-[12.5px]" style={{ color: tile.subColor }}>
              {tile.sub}
            </span>
          </div>
        </button>
      ))}
    </div>
  );
}
